<template>
  <router-view />
</template>

<style lang="scss">
@import "vue-select/src/scss/vue-select.scss";
@import "@/assets/stylesheets/style";
</style>

<script>
import store from "@/store";
import { mapGetters } from "vuex";
import {
  REPORT_UPDATE_LAST_ACTIVE_PATH,
  REPORT_FETCH_STATE
} from "@/store/actions.type";
import { SET_CURRENT_STEP } from "@/store/mutations.type";

export default {
  name: "RoeReportLayout",
  computed: {
    ...mapGetters(["lastStepId"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(REPORT_FETCH_STATE, to.params.id);
    await store.commit(
      SET_CURRENT_STEP,
      store.getters.stepByStepName(to.params.step || to.name)
    );
    let canGoToStep = await store.getters.canGoToStep(
      store.getters.currentStep,
      false
    );
    if (canGoToStep) next();
    else
      next({
        name: "report-edit",
        params: {
          id: to.params.id,
          step: "eligibility"
        }
      });
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch(REPORT_UPDATE_LAST_ACTIVE_PATH, {
      lastActivePath: to.path,
      lastStepId: this.lastStepId,
      id: to.params.id
    });
    next();
  }
};
</script>
